const PREFIX = '[Modal Error]';

export const MODAL_ERROR_SHOW = `${PREFIX} MODAL_ERROR_SHOW`;
export const MODAL_ERROR_HIDE = `${PREFIX} MODAL_ERROR_HIDE`;

export const modalErrorShow = (error, preventPageReload) => ({
  type: MODAL_ERROR_SHOW,
  error,
  preventPageReload,
});

export const modalErrorHide = (_, preventPageReload = false) => {
  if (preventPageReload) {
    const url = window.location.pathname;
    if (url.includes('spa')) {
      const newUrl = window.location.pathname.replace('extras', 'availability');
      window.location.href = newUrl;
    }
  } else {
    window.location.reload();
  }
  return {
    type: MODAL_ERROR_HIDE,
  };
};
